import { useShopTime } from '../../../../Timezone/providers/ShopTimeProvider';
import { useAnalyticsParams } from '../modules/AnalyticsParams/hooks/useAnalyticsParams';
export const useAnalyticsQueryParams = () => {
    const { timezone, convertDateToTimestamp } = useShopTime();
    const { dateRange, groupBy } = useAnalyticsParams();
    return {
        from: convertDateToTimestamp(dateRange.value.dates[0]).toString(),
        to: convertDateToTimestamp(dateRange.value.dates[1]).toString(),
        aggregationTimezone: timezone,
        aggregationPrecision: groupBy.value.value,
    };
};
